import { render, staticRenderFns } from "./NuevoDestinatario.vue?vue&type=template&id=4c5e3d56&"
import script from "./NuevoDestinatario.vue?vue&type=script&lang=js&"
export * from "./NuevoDestinatario.vue?vue&type=script&lang=js&"
import style0 from "./NuevoDestinatario.vue?vue&type=style&index=0&id=4c5e3d56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports